export default __webpack_public_path__ + "static/media/info-circle-filled.221feb58.svg";